import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import useLocales from '../../../hooks/useLocales';

HRStaffBlockedErrorModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  passedData: PropTypes.string,
};

export default function HRStaffBlockedErrorModal({ open, handleClose, passedData: reason }) {
  const { translate } = useLocales();

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" aria-labelledby="staff-blocked-error-dialog">
      <DialogContent>
        <Alert severity="warning">
          {translate('blockedWorkerInsertErrorPrefix')}
          <strong>{reason}</strong>
          {translate('blockedWorkerInsertErrorSuffix')}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleClose} autoFocus>
          {translate('ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
